<template>
  <tr>
    <td>
      {{ value.label }}
    </td>
    <td>
      <!-- icon -->
      <img src="/img/icons/industry_sectors/minerals.png" />
    </td>
    <td>
      <field-item
        v-for="(item, index) in value.children"
        :key="item.id"
        :value="item.label"
        :active="index === selected"
        @click="selected = index" />
    </td>
    <td class="control-btn-wrapper">
      <button class="btn btn-blue" @click="development">Edit</button>
      <button class="btn btn-red" @click="development">Remove</button>
    </td>
  </tr>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  components: {
    'field-item': () => import('./FieldItem.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selected: 0,
  }),
  methods: {
    development() {
      this.$root.$emit('notification', {
        message: 'In development',
        type: 'attention',
        show: true,
      });
    },
  },
});
</script>

<style lang="scss">
  .control-btn-wrapper {
    white-space: nowrap;

    >.btn {
      display: inline-block;
      margin-right: 10px;
    }
  }
</style>
